module.exports = __webpack_public_path__ + "img/xiaozi_shuzhi.ab4cc48f.svg";